import React from 'react';

function ValidFeedback() {
  return (
    <div className="valid-feedback">
        Looks good!
    </div>
  )
}

export default ValidFeedback;